import { MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { EnableSSOForOrgModal } from './EnableSSOForOrgModal';

interface Props {
  accountId: number;
  orgId: number;
}

export const EnableSSOForOrg = ({ accountId, orgId }: Props) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      {isModalOpen && (
        <EnableSSOForOrgModal
          onClose={() => setModalOpen(false)}
          accountId={accountId}
          orgId={orgId}
        />
      )}
      <MenuItem onClick={() => setModalOpen(true)}>
        Enable SSO for Organization
      </MenuItem>
    </>
  );
};
